<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click.native="openDialog"
      >
        <v-icon>add_circle_outline</v-icon>
      </v-btn>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >

        <v-card>
          <v-toolbar
            card
            dense
            color="primary"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon color="white">library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon color="white">save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon color="white">add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon color="white">delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon color="white">first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon color="white">keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon color="white">keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon color="white">last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon color="white">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>

            <holiday
              ref="holidayEntryForm"
              v-bind="dialogData"
            ></holiday>

          </v-card-text>
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      class="elevation-1"
      default-sort="scrapEntryID:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.calendarYear }}</td>

        <td class="text-xs-left">{{ props.item.state }}</td>
        <td class="text-xs-left">{{ props.item.noOfHolidays }}</td>
        <td class="text-xs-left">{{ props.item.addedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedByUser }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getCompanyHolidays, getCompanyHoliday, getStates, getCountries, createCompanyHolidays, updateCompanyHolidays, deleteCompanyHolidays } from '@/api/companyHoliday';
import Holiday from '@/pages/calendar/Holiday';
import { getHolidays } from '@/api/holiday';
import GlobalMessage from '@/constant'
export default {
  components: {
    Holiday,


  },
  data: () => ({
    dialog: false,
    dialogData: null,
    loader: false,
    search: '',

    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'Calendar Year', value: 'year', align: 'left' },

      { text: 'State', value: 'state', align: 'left' },
      { text: 'No of Holidays', value: 'halidays', align: 'left' },
      { text: 'Added By', value: 'plant', align: 'left' },
      { text: 'Modified By', value: 'plant', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    gridItems: [],
    stateItems: [],
    countryItems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      companyHolidayId: -1,
      calendarYear: 2018,
      loginUser: 'Arun',
      isLogin: 'yes-1',
      plantId: null,
      stateId: null,
      noOfHolidays: null,
      reference: '',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      companyHolidayDetail: []
    },
    defaultItem: {
      valid: false,
      companyHolidayId: -1,
      calendarYear: 2018,
      loginUser: 'Arun',
      isLogin: 'yes-1',
      plantId: null,
      stateId: null,
      noOfHolidays: null,
      reference: '',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      companyHolidayDetail: []
    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Blister Scrap' : 'Edit Blister Scrap';
    }
  },

  watch: {
    dialog (val) {

      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.loader = true;
      getCompanyHolidays('')
        .then(response => {
          this.gridItems = response.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
           window.getApp.$emit('APP_API_ERROR', error);
        });

      getStates('')
        .then(response1 => {
          this.stateItems = response1.data;
          //this.$refs.eblisterEntryForm.plasticbags = this.plasticbagsitems;
        })
        .catch(error => {
      window.getApp.$emit('APP_API_ERROR', error);
        });

      getCountries('')
        .then(response2 => {
          this.countryItems = response2.data;
          //this.$refs.eblisterEntryForm.blisterType = this.blisterScrapTypeitems;
        })
        .catch(error => {
         window.getApp.$emit('APP_API_ERROR', error);
        });


    },
    editItem (item) {
      console.log(item);
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.$refs.holidayEntryForm.form = this.editedItem;
      this.dialog = true;
      this.$refs.holidayEntryForm.stateItems = this.stateItems;
      this.$refs.holidayEntryForm.countryItems = this.countryItems;
      this.$refs.holidayEntryForm.$refs.holidayListform.companyHolidayId = this.editedItem.companyHolidayID;
      this.$refs.holidayEntryForm.$refs.holidayListform.initialize();
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteCompanyHolidays(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {
      getCompanyHoliday(this.searchItem)
        .then(response => {
          console.log(response);
          if (response.data.companyHolidayID != null) {
            this.editedItem = response.data;
            this.$refs.holidayEntryForm.form = this.editedItem;
            this.$refs.holidayEntryForm.stateItems = this.stateItems;
            this.$refs.holidayEntryForm.countryItems = this.countryItems;
            this.$refs.holidayEntryForm.$refs.holidayListform.companyHolidayId = this.editedItem.companyHolidayID;
            this.$refs.holidayEntryForm.$refs.holidayListform.initialize();
            let index = this.gridItems.map(item => item.companyHolidayID).indexOf(response.data.companyHolidayID)
            this.editedIndex = index;
          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No more Record to found');
          }
        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.companyHolidayID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.companyHolidayID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.companyHolidayID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.companyHolidayID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    openDialog () {
      this.add();
      this.dialog = true;
    },
    add () {
      this.editedItem = this.defaultItem;
      this.$refs.holidayEntryForm.form = this.editedItem;
      this.$refs.holidayEntryForm.stateItems = this.stateItems;
      this.$refs.holidayEntryForm.countryItems = this.countryItems;
      this.$refs.holidayEntryForm.$refs.holidayListform.companyHolidayId = -1;
      this.$refs.holidayEntryForm.$refs.holidayListform.initialize();
      this.editedIndex = -1;
      this.$refs.holidayEntryForm.$refs.holidayListform.gridItems = [];
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;
      console.log(this.editedItem);
      deleteCompanyHolidays(this.$refs.holidayEntryForm.form)
        .then(() => {
          //this.loader = false;
          //this.editedItem = null;
          this.add();
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save () {
      this.editedItem = this.$refs.holidayEntryForm.form;
      this.editedItem.companyHolidayDetail = this.$refs.holidayEntryForm.$refs.holidayListform.gridItems;
      console.log(this.editedItem);
      if (this.$refs.holidayEntryForm.$refs.holidayform.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateCompanyHolidays(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
             window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.companyHolidayId = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createCompanyHolidays(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;             
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.companyHolidayId).indexOf(response.data.companyHolidayId)
              this.editedIndex = index;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/calendar/HolidayList.vue